import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from '../../services/apiClient';

export default function BillingSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const refreshStatus = async () => {
      try {
        await apiClient.get(`/subscription/status`);
      } catch (e) {
        console.error(e);
      } finally {
        setTimeout(() => navigate("/dashboard"), 2000);
      }
    };

    refreshStatus();
  }, []);

  return (
    <div className="container text-center mt-5">
      <h2>✅ Payment Successful</h2>
      <p>Redirecting to dashboard…</p>
    </div>
  );
}
